import { Option } from './Option';

export enum ConverterCategory {
    SOLAR_INVERTER = 'solar-inverter',
    HYBRID_INVERTER = 'hybrid-inverter',
    MPPT_TRACKER = 'mppt-tracker',
    RECTIFIER = 'rectifier',
    PCS = 'pcs',
    DC_DC_CONVERTER = 'dc-dc-converter',
    SOLID_STATE_TRANSFORMER = 'solid-state-transformer',
}

export const ConverterCategoryOptions: Option<ConverterCategory>[] = [
    { value: ConverterCategory.SOLAR_INVERTER, label: 'Solar Inverter' },
    { value: ConverterCategory.HYBRID_INVERTER, label: 'Hybrid Inverter' },
    { value: ConverterCategory.MPPT_TRACKER, label: 'DC Optimizer' },
    { value: ConverterCategory.RECTIFIER, label: 'Rectifier' },
    { value: ConverterCategory.PCS, label: 'Power Conversion Systems' },
    { value: ConverterCategory.DC_DC_CONVERTER, label: 'DC-DC Converter' },
    {
        value: ConverterCategory.SOLID_STATE_TRANSFORMER,
        label: 'Solid State Transformer',
    },
];
